import Tippy from '@tippyjs/react';
import type { Placement as TippyPlacement } from 'tippy.js';
import 'tippy.js/dist/tippy.css';
import 'tippy.js/themes/light.css';

export const Tooltip = Tippy;
export type Placement = TippyPlacement;
